import { useRef, useState } from "react";
import PortalPopout from "../common/Popout/PortalPopout";
import Icon from "../common/Icon";

function Header({
	title,
	subtitle,
	titleChildren = null,
	actions = null,
	icon,
	sticky = false,
	className = "",
	children = null,
}) {
	const IconComponent = icon;
	const actionsButtonRef = useRef(null);
	const [actionsVisible, setActionsVisible] = useState(false);
	const toggleActions = () => setActionsVisible((prev) => !prev);
	return (
		<header
			className={`flex gap-6 bg-white p-8 shadow-sm ${className || ""} ${
				sticky ? "sticky top-0 z-10" : ""
			}`}
		>
			<section className="flex gap-6 items-center justify-between flex-1">
				<div className="flex gap-6 items-center w-full">
					<div className="flex gap-2 flex-wrap justify-between items-center w-full">
						<div className="flex gap-6 items-center">
							{icon && (
								<IconComponent className="w-8 h-8 md:w-12 md:h-12 text-black" />
							)}
							<div className="flex flex-col">
								{typeof subtitle === "string" && (
									<span className="text-the-brown font-sans-wide uppercase">
										{subtitle}
									</span>
								)}
								{["string", "boolean"].includes(
									typeof subtitle
								) === false && subtitle}
								<h1 className="text-2xl md:text-4xl font-normal font-avec m-0">
									{title}
								</h1>
							</div>
							{titleChildren}
						</div>
						{actions && (
							<>
								<div className="gap-2 hidden md:flex print:hidden flex-wrap">
									{actions}
								</div>
								<button
									ref={actionsButtonRef}
									type="button"
									aria-label="Open actions menu"
									className="flex md:hidden print:hidden cursor-pointer text-xl"
									onClick={toggleActions}
								>
									<Icon
										name="caret-right"
										size="2xl"
										className="rotate-90"
									/>
								</button>
								<PortalPopout
									isOpen={actionsVisible}
									triggerRef={actionsButtonRef}
									onClose={() => setActionsVisible(false)}
									className="w-4/5 max-w-xs"
									zIndex={152}
								>
									<div className="flex flex-col gap-4 p-8">
										{actions}
									</div>
								</PortalPopout>
							</>
						)}
					</div>
				</div>
			</section>
			{children}
		</header>
	);
}

export default Header;
